<template>
  <v-card>
    <v-card-text>
      <h3>Length</h3>
      <convert-box></convert-box>
    </v-card-text>
  </v-card>
</template>

<script>
import ConvertBox from '../components/ConvertBox'

export default {
  components: { ConvertBox },
  data() {
    return {
      unit: [
        {
          text: 'Meter',
          val: 1
        },
        {
          text: 'Kilometer',
          val: 0.001
        },
        {
          text: 'Centimeter',
          val: 100
        },
        {
          text: 'Millimeter',
          val: 1000000
        },
        {
          text: 'Nanometer',
          val: 1000000000
        },
        {
          text: 'Mile',
          val: 0.0006213689
        },
        {
          text: 'Yard',
          val: 1.0936132983
        },
        {
          text: 'Foot',
          val: 3.280839895
        },
        {
          text: 'Inch',
          val: 39.37007874
        },
        {
          text: 'Light Year',
          val: 1.057008707e-16
        }
      ]
    }
  },
  created() {
    this.$store.dispatch('setUnit', this.unit)
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// length.vue?53b94b62